export default "__VITE_ASSET__COPZYKTt__"